module.exports = __webpack_public_path__ + "static/media/canes-1.aea9c326.png";